import apiClient from './api'

/**
 * Config Service
 *
 * Service for fetching application configuration from the backend API
 */

/**
 * Fetch tenant configuration
 * @returns {Promise<Object>} Tenant configuration with branding info
 */
export const getTenantConfig = async () => {
  try {
    const response = await apiClient.get('/health/tenant')
    return response.data
  } catch (error) {
    console.error('Error fetching tenant config:', error)
    // Return default fallback
    return {
      tenant_name: '6 Percent Wine',
      tenant_id: 'R7JD8933',
      display_name: '6 Percent Wine',
      app_title: 'Calon Pulse (Beta) for 6 Percent Wine'
    }
  }
}

export default {
  getTenantConfig,
}
